const patientTherapies = 
{
  data: {
    data: [
      {
        "docId": "docId1",
        "nombre_esquema": "Nombre esquema 1",
        "nombre_terapia": "Nombre terapia 1",
        "creado_por": "anonimus@neumomed.com",
        "estado": "Sin empezar",
        "progreso": 0
      },
      {
        "docId": "docId2",
        "nombre_esquema": "Nombre esquema 2",
        "nombre_terapia": "Nombre terapia 2",
        "creado_por": "anonimus@neumomed.com",
        "estado": "En progreso",
        "progreso": 25
      },
      {
        "docId": "docId3",
        "nombre_esquema": "Nombre esquema 3",
        "nombre_terapia": "Nombre terapia 3",
        "creado_por": "anonimus@neumomed.com",
        "estado": "Cancelado",
        "progreso": 50
      },
    ]
  }
};


module.exports = {
  patientTherapies
}


// WEBPACK FOOTER //
// ./src/components/Terapias/mocks.js